import React from 'react'
import { CSSTransition } from 'react-transition-group'

import { CheckmarkCircleSvg } from '@src/components/adgroup-svg/react'

import { PropertyOption as PropertyOptionType } from '@pages/properties-view/house-and-land/v2/lots-side-panel/lot-card/types'

import { formatPrice } from '@utilities/helper'

import AssetHandler from '@adUtilities/asset-handler/asset-handler'

type OptionalFields = 'price' | 'images' | 'thumbnail'

export type Option = Omit<PropertyOptionType, OptionalFields> &
  Partial<Pick<PropertyOptionType, OptionalFields>>

interface PropertyOptionProps {
  isSelected: boolean
  option: Option
  onClick: () => void
  showAsThumbnail: boolean
}

const PLACEHOLDER_IMAGE = process.env.REACT_APP_PLACEHOLDER_IMAGE_URL

function PropertyOption({
  isSelected,
  option,
  onClick,
  showAsThumbnail,
}: PropertyOptionProps) {
  return showAsThumbnail ? (
    <div
      className="relative h-[60px] cursor-pointer overflow-hidden rounded"
      onClick={onClick}
      role="none"
    >
      <CSSTransition
        in={isSelected}
        timeout={500}
        classNames="transition-fade-ease"
      >
        {isSelected ? (
          <div>
            <div className="absolute inset-0 bg-black/60"></div>
            <CheckmarkCircleSvg className="absolute bottom-1 right-1 z-10 h-[20px] w-[20px] invert" />
          </div>
        ) : (
          <div></div>
        )}
      </CSSTransition>
      {option.price ? (
        <div className="bg-gradient-left-to-right absolute bottom-[8px] left-0 inline-flex break-all pl-[7px] pr-[20px]">
          <span className="text-[13px] font-medium leading-[11px] text-white">
            +{formatPrice(option.price)}
          </span>
        </div>
      ) : null}
      <img
        className="h-full w-full object-cover"
        alt="thumbnail"
        src={AssetHandler({
          url: String(
            option?.thumbnail?.url ||
              option.images?.[0]?.url ||
              PLACEHOLDER_IMAGE
          ),
          type: 'new',
          staticUrl: true,
        })}
      />
    </div>
  ) : (
    <div
      className={`col-span-2 cursor-pointer rounded px-4 py-2 transition-all duration-300 ${
        isSelected ? 'bg-mainColour' : 'bg-zinc-200'
      }`}
      onClick={onClick}
      role="none"
    >
      <div
        className={`flex items-center justify-between gap-1 transition-all duration-300 ${
          isSelected ? 'text-white' : ''
        } font-medium`}
      >
        <span className="leading-[19px]">{option.name}</span>
        {option.price ? (
          <span className="text-[13px] leading-[15.5px] opacity-60">
            +{formatPrice(option.price)}
          </span>
        ) : null}
      </div>
    </div>
  )
}

export default PropertyOption
